<template>
    <v-sheet class="health-card-rounded mr-2">
        <v-row no-gutters class="pa-2">
            <v-col cols="12">
                <span class="title-card">
                    {{ title }}
                </span>
            </v-col>
            <v-col cols="12">
                <v-row no-gutters justify="space-between">
                    <span class="text-card">
                        {{ value }}
                    </span>
                    <span class="text-unit-card">
                        {{ unitComputed }}
                    </span>
                </v-row>
            </v-col>
        </v-row>
    </v-sheet>
</template>

<script>
import i18n from '@/i18n';

export default {
    props: ["value", "title"],
    computed: {
        unitComputed() {
            try {
                let unit = {
                    น้ำหนัก: i18n.t('message.form.healthData.kg'),
                    ส่วนสูง: i18n.t('message.form.healthData.cm'),
                    หมู่เลือด: "",
                    Weight: i18n.t('message.form.healthData.kg'),
                    Height: i18n.t('message.form.healthData.cm'),
                };
                return unit[this.title];
            } catch (error) {
                return "";
            }
        },
    },
};
</script>

<style scoped lang="scss">
.health-card-rounded {
    background: #ccf3e7;
    border: 1px solid #66dcb7;
    border-radius: 10px;
}
.title-card {
    font-family: "Prompt";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #37323c;
}
.text-card {
    font-family: "Sarabun";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #37323c;
}
.text-unit-card {
    font-family: "Sarabun";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #37323c;
}

[class*="-card"] {
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
</style>
